export const GET_VEHICLE_PACKAGES = "GET_VEHICLE_PACKAGES";
export const ADD_VEHICLE_PACKAGE = "ADD_VEHICLE_PACKAGE";
export const EDIT_VEHICLE_PACKAGE = "EDIT_VEHICLE_PACKAGE";
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS'